import React from "react";
import {
  Box,
  Stack,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  SvgIcon,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import "./MapGuessHistory.scss";

const MapGuessHistory = ({ guessHistory, height = "300" }) => {
  const handleCopyCoordinates = (coordinates) => {
    navigator.clipboard
      .writeText(`(${coordinates.lat}, ${coordinates.lng})`)
      .then(() => {})
      .catch((err) => {
        console.error("Could not copy coordinates: ", err);
      });
  };

  return (
    <Stack
      className="guess-history-container"
      sx={{ height: `${height}px`, overflowY: "auto", p: 2 }}
    >
      {guessHistory.length === 0 ? (
        <Typography className="no-guesses-text">
          No coordinate guesses yet. Use the map to make attempts.
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>No.</TableCell>
                <TableCell>Coordinates</TableCell>
                <TableCell>Feedback</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guessHistory.map((guess, index) => {
                const lat =
                  Array.isArray(guess.coordinates) &&
                  guess.coordinates.length >= 2
                    ? guess.coordinates[0]
                    : guess.coordinates?.lat;

                const lng =
                  Array.isArray(guess.coordinates) &&
                  guess.coordinates.length >= 2
                    ? guess.coordinates[1]
                    : guess.coordinates?.lng;

                return (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                        }}
                      >
                        {Array.isArray(guess.coordinates)
                          ? guess.coordinates.map((coord, i) => (
                              <Typography
                                key={i}
                                variant="body2"
                                sx={{
                                  fontWeight: "medium",
                                  fontFamily: "monospace",
                                }}
                              >
                                ({coord.lat}, {coord.lng})
                              </Typography>
                            ))
                          : typeof guess.coordinates === "object" && (
                              <Typography
                                variant="body2"
                                sx={{
                                  fontWeight: "medium",
                                  fontFamily: "monospace",
                                }}
                              >
                                ({guess.coordinates.lat},{" "}
                                {guess.coordinates.lng})
                              </Typography>
                            )}
                        <Typography variant="caption" className="timeStem">
                          {guess.timestamp}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell>
                      {/* <Typography variant="body2">
                        {guess.success
                          ? "Direct hit! Coordinates matched."
                          : "Missed. Try another location."}
                      </Typography> */}
                      {guess.feedback && guess.feedback.length > 0 && (
                        <Box sx={{ mt: 0.5 }}>
                          {/* {Array.isArray(guess.feedback)
                              ? guess.feedback.map((msg, i) => (
                                  <Typography
                                    key={i}
                                    variant="body2"
                                    sx={{ fontSize: "0.8rem" }}
                                  >
                                    • {msg}
                                  </Typography>
                                ))
                              : typeof guess.feedback === "string" && (
                                  <Typography
                                    variant="body2"
                                    sx={{ fontSize: "0.8rem" }}
                                  >
                                    • {guess.feedback}
                                  </Typography>
                                )} */}
                          <Typography
                            variant="body2"
                            sx={{ fontSize: "0.8rem" }}
                          >
                            {guess.feedback[0]}
                          </Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip
                        title="Copy coordinates"
                        arrow
                        slotProps={{
                          tooltip: { className: "MuiTooltip-tooltip" },
                          popper: { disablePortal: true },
                        }}
                      >
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleCopyCoordinates({
                              lat: lat || 0,
                              lng: lng || 0,
                            })
                          }
                          aria-label="copy coordinates"
                        >
                          {/* <ContentCopyIcon fontSize="small" color="inherit" /> */}
                          <SvgIcon
                            component={ContentCopyIcon}
                            color="inherit"
                          />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Stack>
  );
};

export default MapGuessHistory;
